"use strict";

exports.__esModule = true;
var _exportNames = {};
exports.default = void 0;
var _indexDefault = _interopRequireDefault(require("./index-default.js"));
exports.default = _indexDefault.default;
var _index = require("./index.js");
Object.keys(_index).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
  if (key in exports && exports[key] === _index[key]) return;
  exports[key] = _index[key];
});
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }